import DashboardSplitChartEmptyState from "./DashboardSplitChartEmptyState";

export default DashboardSplitChartEmptyState;
